/* eslint-disable react/jsx-props-no-spreading */
/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import { Box } from '@material-ui/core';
import Button from 'components/ChoreoSystem/Button/Button';
import useStyles from './AuthenticateButton.styles';

interface AuthenticateButtonProps {
  children: React.ReactNode;
  testId: string;
  startIcon?: React.ReactNode;
  fullWidth?: boolean;
  onClick?: () => void;
}

function AuthenticateButton(props: AuthenticateButtonProps) {
  const { children, startIcon, testId, fullWidth = true, onClick } = props;
  const classes = useStyles();
  const isInIframe = window.self !== window.top;

  return (
    <Button
      id={testId}
      className={isInIframe ? classes.loginBtnEmbedded : classes.loginBtn}
      variant="subtle"
      testId={testId}
      color="secondary"
      fullWidth={fullWidth}
      onClick={onClick}
    >
      {startIcon && <Box className={classes.btnIcon}>{startIcon}</Box>}
      <Box className={classes.btnText}>{children}</Box>
    </Button>
  );
}

export default AuthenticateButton;
